import {
  axiosDataApi
} from '../../axios_init'

import {
  saveData,
  delData
} from '@/api/local_storage'

const state = {
  assign_data: [],
  solution_data: [],
  centroids: [],
  cluster_cutomer: [],
  cars: [],
  car_routes: []
}

const getters = {
  assignData: state => state.assign_data,
  clusterCutomer: state => state.cluster_cutomer,
  centroids: state => state.centroids,
  cars: state => state.cars,
  carRoutes: state => state.car_routes,
  solutionData: state => state.solution_data
}

const actions = {
  setAssignData ({ commit, dispatch }, data) {
    commit('changeAssignData', data)
    dispatch('delAssignData', data)
  },
  saveAssignData ({ getters }, data) {
    saveData({key: 'assign_data' + data, data: getters.assignData})
  },
  clearAssignData ({ commit }, data) {
    delData('assign_data' + data)
  },
  saveRouteData  ({ getters }, data) {
    saveData({key: 'solution_data' + data, data: getters.solutionData})
  },
  clearRouteData ({ commit }, data) {
    delData('solution_data' + data)
  },
  initAssignData ({ commit, dispatch }, data) {
    if (data === 'clear' || !data.centroids) {
      commit('changeAssignData', {})
      dispatch('setCars', [])
      dispatch('setCentroids', [])
      dispatch('setClusterCutomer', [])
      dispatch('setMapDataCenter', [])
      return
    } else {
      dispatch('delAssignData', data)
    }
  },
  setSolutionData ({ commit, dispatch }, data) {
    commit('changeSolutionData', data === 'clear' ? {} : data)
    dispatch('delSolutionData', data)
  },
  setClusterCutomer ({ commit }, data) {
    commit('changeClusterCutomer', data)
  },
  setCentroids ({ commit }, data) {
    commit('changeCentroids', data)
  },
  setCars ({ commit }, data) {
    commit('changeCars', data)
  },
  setCarRoutes ({ commit }, data) {
    commit('changeCarRoutes', data)
  },
  delAssignData ({ commit, dispatch }, data) {
    let centroidsData = []
    let carsData = []
    let mapDataCenter = []
    data.centroids.forEach(function (item) {
      let carName = '车辆' + item[0].slice(2)
      carsData.push(carName)
      centroidsData.push({'car_name': carName, 'center': item[3], 'customer_num': item[4], 'order_num': item[5], 'distance': item[6]})
      mapDataCenter.push({
        name: '车辆' + item[0].slice(2) + '-' + item[3],
        value: [item[1], item[2], {
          center: item[3],
          customer_num: item[4],
          order_num: item[5],
          distance: item[6]
        }]
      })
    })
    dispatch('setCars', carsData)
    dispatch('setCentroids', centroidsData)
    dispatch('setClusterCutomer', data.clustercutomer)
    dispatch('setMapDataCenter', mapDataCenter)
    dispatch('setSolutionStatus', 30)
  },
  delSolutionData ({ commit, getters, dispatch }, data) {
    if (data === 'clear' || !data['路线']) {
      dispatch('setCarRoutes', [])
      dispatch('setMapDataRoute', [])
      return
    }
    let routeData = []
    let mapRouteData = []
    data['路线'].forEach(function (item) {
      let mapRouteDataOne = {'name': '车辆' + item[0].slice(2), data: []}
      routeData.push({
        car: '车辆' + item[0].slice(2),
        route_data: item.slice(1).sort((a, b) => a[2] > b[2] ? 1 : -1)
      })
      item.slice(1).forEach(function (item) {
        let from = getters.shopCoordinate[item[0]]
        let to = getters.shopCoordinate[item[1]]
        if (from && to) {
          mapRouteDataOne.data.push({
            fromName: item[0],
            toName: item[1],
            coords: [from, to]
          })
        }
      })
      mapRouteData.push(mapRouteDataOne)
    })
    dispatch('setCarRoutes', routeData)
    dispatch('setMapDataRoute', mapRouteData)
    dispatch('setSolutionStatus', 40)
  },
  startAssignData ({ commit, getters, dispatch }, data) {
    if (getters.solutionDay !== 0 && !getters.solutionDay) {
      dispatch('showNoticeMsg', {
        type: 'warning',
        title: '系统提示',
        message: '请先选择送货日期！'
      })
      return
    }
    dispatch('setLoading', true)
    dispatch('setLoadingText', '分配客户中')
    dispatch('setPercentage', {'start': 0, 'next': 60})
    dispatch('setSolutionStatus', 25)
    let postData = {
      parameter: getters.parm,
      OrderDays: getters.sourceData.OrderDays,
      Plant: getters.sourceData.Plant,
      Location: getters.sourceData.Location,
      Distance: getters.sourceData.Distance,
      week: getters.solutionWeeks[getters.solutionDay],
      solvericon: getters.solutionWays[getters.solutionWay],
      solver: 'AssignClusters5',
      ct: getters.sourceData.ct
    }
    console.log('开始分配客户')
    axiosDataApi.post('/solve', window.JSON.stringify(postData)).then(function (response) {
      console.log('分配客户完成')
      dispatch('setLoadingText', '解析客户数据')
      dispatch('setPercentage', {'start': 60, 'next': 100})
      dispatch('setAssignData', response.data)
      dispatch('setLoadingText', '分配完成')
      dispatch('setPercentage', {'start': 100, 'next': 100})
    }).catch(function (e) {
      dispatch('setSolutionStatus', 20)
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '分配客户异常',
        message: '错误信息:' + e
      })
      dispatch('setLoadingText', '分配客户异常')
      dispatch('setPercentage', {'start': 100, 'next': 100})
      console.log(e)
    })
  },
  startSolutionData ({ commit, getters, dispatch }) {
    dispatch('setLoading', true)
    dispatch('setLoadingText', '求解路径中')
    dispatch('setPercentage', {'start': 0, 'next': 60})
    dispatch('setSolutionStatus', 35)
    let postData = {
      parameter: getters.parm,
      ClusterMiddle: getters.assignData.ClusterMiddle,
      Distance: getters.sourceData.Distance,
      Location: getters.sourceData.Location,
      OrderDays: getters.sourceData.OrderDays,
      Plant: getters.sourceData.Plant,
      centroids: getters.assignData.centroids,
      cpc: getters.assignData.cpc,
      week: getters.solutionWeeks[getters.solutionDay],
      solver: 'CreateRoutes5'
    }
    console.log('开始求解路径')
    axiosDataApi.post('/solve', window.JSON.stringify(postData)).then(function (response) {
      dispatch('setLoadingText', '解析路径')
      dispatch('setPercentage', {'start': 60, 'next': 100})
      console.log('求解路径完成')
      dispatch('setSolutionData', response.data)
      dispatch('setLoadingText', '求解完成')
      dispatch('setPercentage', {'start': 100, 'next': 100})
    }).catch(function (e) {
      dispatch('setSolutionStatus', 30)
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '求解路径异常',
        message: '错误信息:' + e
      })
      dispatch('setLoadingText', '求解路径异常')
      dispatch('setPercentage', {'start': 100, 'next': 100})
      console.log(e)
    })
  }
}

const mutations = {
  changeAssignData (state, data) {
    state.assign_data = data
  },
  changeSolutionData (state, data) {
    state.solution_data = data
  },
  changeClusterCutomer (state, data) {
    state.cluster_cutomer = data
  },
  changeCentroids (state, data) {
    state.centroids = data
  },
  changeCars (state, data) {
    state.cars = data
  },
  changeCarRoutes (state, data) {
    state.car_routes = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/assign.js